import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-sidebar',
  templateUrl: './app-sidebar.component.html'
})
export class AppSidebarComponent { }
